import * as React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "../../../firebase-config";
import { useParams } from "react-router-dom";


export default function CompanyFilings() {
  let params = useParams();
  const id = params.companyId;
  const [loading, setLoading] = React.useState(true);
  const [companyName, setCompanyName] = React.useState();
  const [filings, setFilings] = React.useState([]);

  const list = Array.from({ length: 16 }, (v, k) => k + 1);

  async function fetchFilings({ id }) {
    setLoading(true);
    const q = query(
      collection(db, "filings"),
      where("company-id", "==", id),
      orderBy("year", "desc")
    );

    const allDocs = [];
    let name;
    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      allDocs.push(doc.data());
      name = doc.data()["company_name"]
    });

    setFilings(allDocs);
    setCompanyName(name)
    setLoading(false);
  }

  React.useEffect(() => {
    fetchFilings({ id });
  }, [id]);

  return loading ? (
    <Box>
      <Box sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}>
        <Typography variant="h4" align="center" justifyContent={"center"}>
          <Skeleton width={300} sx={{ bgcolor: "white", }} />
        </Typography>
      </Box>

      <Typography sx={{ mt: 2, mb: 2 }} variant="h5" align="center">
        Company Filings
      </Typography>
      <Grid container spacing={2}>
        {list.map((index) => {
          return (
            <Grid item xs={12} md={6} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h5" align="center">
                    <Skeleton width="50%" sx={{ bgcolor: "white" }} />
                  </Typography>
                  <Typography variant="subtitle2">
                    <Skeleton width="25%" sx={{ bgcolor: "white" }} />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  ) : filings.length === 0 ? (
    <Box>
      <Typography variant='h5' align="center">
        No Data Available
      </Typography>
    </Box>
  ) : (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" component="div" align="center">
        {companyName}
      </Typography>
      <Typography sx={{ mt: 2, mb: 2 }} variant="h5" component="div" align="center">
        Company Filings
      </Typography>
      <List>
        <Grid container spacing={2}>
          {filings.map((filing) => {
            return (
              <Grid key={filing["link"]} item xs={12} md={6}>
                <Card>
                  <ListItem
                    secondaryAction={
                      <IconButton href={filing["link"]} target="_blank" rel="noopener noreferrer" color="secondary" edge="end" aria-label="download">
                        <FileOpenOutlinedIcon />
                      </IconButton>
                    }
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <FilePresentOutlinedIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={filing["filing_type"]}
                      secondary={filing["year"]}
                    />
                  </ListItem>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      </List>
    </Box>
  );
}
